import { Box, Grid, Stack, styled, Typography } from "@mui/material";
import { primary } from "../../constants/theme";
import { vehicles } from "../../constants/vehicleData";
import StoreVehicleCards from "./vehicleCards";

const CustomBrandVehicleList = styled(Box)(({ theme }) => ({
  ".headerInfo": {
    fontSize: "28px",
    fontWeight: "600",
  },

  ".headerBorder": {
    width: "100px",
    height: "8px",
    borderRadius: "100px",
    background: primary.main,
  },
  [theme.breakpoints.down("md")]: {
    ".headerInfo": {
      fontSize: "22px",
    },

    ".headerBorder": {
      width: "60px",
      height: "6px",
      borderRadius: "100px",
      background: primary.main,
    },
  },
}));

const BrandVehicleList = () => {
  return (
    <CustomBrandVehicleList>
      <Stack
        sx={{
          margin: {
            xs: "32px 16px 16px 16px",
            sm: "16px 0px 16px 32px",
            md: "16px 0px 16px 32px",
          },
        }}
      >
        <Typography flexDirection={"column"} className="headerInfo">
          One Store for best Electric Gadi Brands
        </Typography>
        <Box className="headerBorder" />{" "}
      </Stack>
      <Grid container spacing={2}>
        {vehicles.map((data, index) => {
          return (
            <Grid
              key={index}
              item
              xs={12}
              sm={6}
              md={3}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
              //columnSpacing={1}
            >
              <StoreVehicleCards vehicleData={data} />
            </Grid>
          );
        })}
      </Grid>
    </CustomBrandVehicleList>
  );
};

export default BrandVehicleList;
